export default __webpack_public_path__ + "static/screenshots-generator-0-39d9f0a5bba69f4cb98173e205ae82c2.png";